import { render, staticRenderFns } from "./global-prompt-time.vue?vue&type=template&id=27f07da0&scoped=true&"
import script from "./global-prompt-time.vue?vue&type=script&lang=js&"
export * from "./global-prompt-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f07da0",
  null
  
)

export default component.exports